export default () => {
    return {
        isPlaying: false,
        init() {
            this.$refs.audio.ontimeupdate = () => {
                this.$nextTick(() => {
                    this.$refs.progress.value = this.$refs.audio.currentTime / this.$refs.audio.duration;
                });
            };

            this.$refs.audio.onended = () => {
                this.isPlaying = false;
                this.$refs.progress.value = 0;
                this.$refs.audio.currentTime = 0;
            };

            this.$refs.progress.onclick = (event) => {
                this.setProgress(event);
            };

            this.$refs.progress.onmousemove = (event) => {
                if (event.buttons === 1) {
                    this.setProgress(event);
                }
            };

            this.$watch('isPlaying', (value) => {
                if (value === true) {
                    this.$refs.audio.play()
                } else {
                    this.$refs.audio.pause()
                }
            });
        },
        play() {
            this.isPlaying = true;
        },
        pause() {
            this.isPlaying = false;
        },
        toggleAudio() {
            this.isPlaying ? this.pause() : this.play();
        },
        setProgress(event) {
            this.$refs.audio.currentTime = (event.offsetX / this.$refs.progress.offsetWidth) * this.$refs.audio.duration;
            this.$refs.progress.value = event.offsetX / this.$refs.progress.offsetWidth;
        }
    };
}
